import { SystemField } from "./system-field";

export class PhysicalCountDetail extends SystemField{ 
     physical_count_id?:string;
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     location_id?:string;
     unit_cost?:number;
     actual_qty?:number;
     on_hand_qty?:number;
     adj_qty?:number;
     langs?:any;
}
export class PhysicalCountDetailTranslate extends SystemField{ 
     lang_code?:string;
     phycount_detail_id?:string;
     description?:string;
}

